export const getCustomerLabel = (
  customerAccountNumber: string | undefined | null,
  customerName: string | undefined | null,
  postCode: string | undefined | null,
) => {
  const addPostCode = postCode ? `, ${postCode}` : '';

  return customerAccountNumber ? `[${customerAccountNumber}] - ${customerName}${addPostCode}` : '';
};
